import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-negotiation';

export default function Example() {
  return (
    <>
      <Head>
        <title>How To Negotiate On Poshmark - The Seller's Guide to Effective Offers</title>
        <meta
          name='description'
          content='As with any business, negotiation is a key factor that makes a transaction successful. Find out how you can effectively negotiate with your potential buyers and see how it can help you increase your sales!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-negotiation' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-negotiation' />
        <meta property='og:title' content="How To Negotiate On Poshmark - The Seller's Guide to Effective Offers" />
        <meta
          property='og:description'
          content='As with any business, negotiation is a key factor that makes a transaction successful. Find out how you can effectively negotiate with your potential buyers and see how it can help you increase your sales!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
